export enum MixpanelEvent {
  UserLoggedIn = 'user_logged_in',
}

export interface MixpanelEventProperties {
  [MixpanelEvent.UserLoggedIn]: {
    group_id: string;
    group_name: string;
    user_id: string;
    user_email: string;
  };
}
